import { flatten } from 'lodash';
import { Instance, types as t } from 'mobx-state-tree';

import { CorrectOption } from '../../../question-data-model/Question/CorrectOption/correct-option.store';
import { ExtraQuestionProps } from '../../components/questions/BaseQuestion';
import { ResultTestQuestionStore } from '../result-test-question.store';
import { FlowChartDragDropAnswerQuestion } from '../../../question-data-model/Question/_implementations/flowchart-drag-drop-question.store';

export const ResultFlowChartDragDropQuestion = t
  .compose(ResultTestQuestionStore, FlowChartDragDropAnswerQuestion)
  .props({
    correctOptions: t.array(CorrectOption),
  })
  .named('ResultFlowChartDragDropQuestion')
  .views((self) => ({
    get questionCount() {
      return self.correctAnswers.length;
    },

    getQuestions() {
      let currentIndex = 0;
      const sentencesResult = self.sentences.map((sentence) => {
        const blankItems = sentence.blanks.map((blank) => {
          const correctKey = self.correctAnswers.find((it) => it.blankId === blank.id)?.key;

          return {
            ...blank,
            no: self.no + blank.key,
            markedType: self.marked[blank.key],
            userAnswer: self.userAnswers.find((it) => it.blankId === blank.id)?.userAnswer,
            correctAnswer: self.options.find((x) => x.key === correctKey).value,
          };
        });
        return {
          ...sentence,
          editorValueJS: sentence.editorValueJS,
          blanks: blankItems,
        };
      });
      return flatten(
        self.sentences.map((sentence) => {
          return sentence.blanks.map((blank) => {
            const userAnswer = self.userAnswers.find((it) => it.blankId === blank.id)?.userAnswer;
            const correction = self.correctAnswers.find((it) => it.blankId === blank.id);
            const extraProps: ExtraQuestionProps = {
              no: self.no + blank.key,
              markedStatus: self.marked[blank.key],
              corrections: self.correctAnswers,
              index: currentIndex,
              userAnswerKey: userAnswer,
              correctAnswerKey: correction?.value,
              userAnswer,
              correction,
              blank,
            };
            currentIndex += 1;
            return {
              ...self,
              ...extraProps,
              sentences: sentencesResult,
            };
          });
        })
      );
    },
  }));

export interface ResultFlowChartDragDropQuestionInstance
  extends Instance<typeof ResultFlowChartDragDropQuestion> {}
